import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Technology } from '@price-card/models/technology.model';

export interface TechnologiesState {
  technologies: Technology[];
  isFetching: boolean;
  error?: string;
}

const initialState: TechnologiesState = {
  technologies: [],
  isFetching: false,
};

export const technologiesSlice = createSlice({
  name: 'technologies',
  initialState,
  reducers: {
    retrieveTechnologies: state => {
      state.isFetching = true;
    },
    retrieveTechnologiesSuccess: (state, action: PayloadAction<Technology[]>) => {
      state.technologies = [...action.payload].sort((a, b) => a.name.localeCompare(b.name));
      state.isFetching = false;
    },
    retrieveTechnologiesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export type TechnologiesViewModel = {
  technologies: Technology[];
  isFetching: boolean;
  error?: string;
};

export const selectTechnologiesViewModel = createSelector(
  (state: RootState) => state,
  (state): TechnologiesViewModel => ({
    technologies: state.priceCard.technologies.technologies,
    isFetching: state.priceCard.technologies.isFetching,
    error: state.priceCard.technologies.error,
  }),
);
export const { retrieveTechnologies, retrieveTechnologiesSuccess, retrieveTechnologiesFailure } =
  technologiesSlice.actions;

export default technologiesSlice.reducer;
